import { getToken } from '../../Utils/authUtils';
import { createAsyncThunk } from '@reduxjs/toolkit';
import { DISTRIBUTION } from '../../constant';

export interface EmailDistributionPayload {
  reportId: string;
  /** Recipient address, as typed. The server normalises and records it. */
  toEmail: string;
  /** Optional display name, used for the greeting and stored on the record. */
  toName?: string;
  /** Optional covering note shown in the email body. */
  note?: string;
  /** When set, sends (and completes) this existing DRAFT instead of creating one. */
  distributionId?: string;
}

/**
 * Email a finalized report's PDF to a typed address.
 *
 * A 502 from this endpoint means the record exists and says FAILED — the report did NOT
 * go out. The rejection message is what the server said went wrong, so it is surfaced
 * verbatim rather than replaced with a generic failure.
 */
export const sendEmailDistributionApi = createAsyncThunk(
  'distribution/sendEmail',
  async (payload: EmailDistributionPayload, { rejectWithValue }) => {
    try {
      const token = getToken();
      if (!token) {
        return rejectWithValue('No token found');
      }
      const response = await fetch(DISTRIBUTION.EMAIL_SEND, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify(payload),
      });

      const result = await response.json().catch(() => ({}));
      if (!response.ok) {
        return rejectWithValue(result.msg || `Email send failed: ${response.status}`);
      }
      return result;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);
